"use strict";

module.exports = ['$scope', 'dashboardSettings', ($scope, dashboardSettings) => {
	$scope.dashboardSettings = dashboardSettings;
}];
